import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const BetGliderCtaRace = observer('BetGliderCtaRace', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='83'
            height='12'
            viewBox='0 0 83 12'
            fill='none'
            className={className}
            onClick={onClick}
        >
            <path
                fill='#e30613'
                d='M0 1.767h6.564q1.337 0 2.034.581.674.558.675 1.597-.002 1.45-1.312 1.947 1.675.422 1.673 2.105 0 1.065-.7 1.647-.72.594-2.083.594H0zM3.132 4.91h2.445q.568.002.568-.426 0-.426-.568-.425H3.132zm0 3.02h2.807q.567.001.568-.425 0-.427-.568-.426H3.132zM19.26 1.767v2.418h-5.782v.726h5.665v2.18h-5.665v.725h5.783v2.419h-8.916V1.767zM28.888 1.767v2.662h-3.132v5.806h-3.131V4.429h-3.132V1.767h9.396zM52.054 8.612l7.04-2.611-6.005-2.612L53.761 0l7.956 3.463c.96.411 1.437 1.407 1.214 2.536s-1.092 2.12-2.215 2.537l-7.866 2.919-1.467.545.672-3.39z'
            />
            <path
                fill='#1d1d1b'
                d='m73.214 1.767-.479 2.418h-5.783l-.144.726h5.665l-.432 2.18h-5.664l-.144.726h5.783l-.48 2.418h-8.915l1.678-8.468zM75.381 10.23H72.25l1.678-8.463h5.577c1.323 0 2.281.289 2.865.87q.857.836.55 2.394c-.261 1.317-.983 2.241-2.168 2.782l1.137 2.418h-3.25l-.908-1.936h-1.965zm.91-4.593h2.552q.82 0 .937-.606.121-.606-.697-.606h-2.552l-.24 1.213M44.4 1.767l-1.15 5.806h4.816l-.527 2.662h-7.95l1.678-8.468zM49.748 1.767h3.132l-1.678 8.468H48.07zM34.437 5.275l-.36 1.815h2.002c-.482.565-1.208.846-2.17.846q-2.289.002-1.906-1.935t2.673-1.936q1.323.002 1.76.726h3.362q-.071-1.511-1.228-2.31c-.786-.558-1.926-.834-3.41-.834-1.775 0-3.203.38-4.289 1.148Q29.287 3.92 28.875 6q-.414 2.08.726 3.206 1.171 1.146 3.834 1.147 2.263.001 3.778-.83l-.142.71h1.809l.982-4.96z'
            />
        </SvgElement>
    );
});
